import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const CPTICDListFetch = createAsyncThunk("CPTICDList/fetch", async (reqBody) => {
    if (reqBody == null && reqBody === undefined) {
        reqBody = {
            "source": "category_list",
            "condition": {
                "limit": 10,
                "skip": 0
            },
            "sort": {
                "field": "createdon_datetime",
                "type": "desc"
            },
            "searchcondition": {},
            "project": {},
            "token": "",
            "count": false
        }
    }

    // console.log("reqBody==>", reqBody);
    let req_body = {};
    req_body = { ...reqBody };
    // console.log("req_body==", req_body);
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(req_body)
    };
    // console.log("process.env==>", process.env);
    const response = await fetch(process.env.REACT_APP_API_URL + "manage-cpt-icd/cpticd-list-count", requestOptions);
    const respdata = await response.json();
    // console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
})
export const fetchSingleCPTICD = createAsyncThunk("fetch/singleCategory", async (reqBody) => {
    // console.warn("<<<<<< inside fetchSingleData >>>>", reqBody)

    const reqOption = {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reqBody)
    };
    const response = await fetch(process.env.REACT_APP_API_URL + "manage-cpt-icd/cpticd-list-count", reqOption);
    const respdata = await response.json();
    console.log("respdata after endpoint fetch==>", respdata);
    return respdata;
});

const CPTICDReducer = createSlice({
    name: "CPTICDReducer",
    initialState: {
        loading: false,
        success: false,
        error: false,
        message: null,
        CPTICDList: [],
        fetchSingleCPTICD: null,
    },
    reducers: {
        clearEditDataCPTICD(state, action) {
            state.fetchSingleCPTICD = null;
        },
    },
    extraReducers: {

        [CPTICDListFetch.pending]: (state, action) => {
            // console.log("action p", action)
            // state.usersList = [];
            state.loading = true;
        },
        [CPTICDListFetch.fulfilled]: (state, action) => {
            console.log("action f storedata", action)
            if (action.payload.status === 'success') {

                state.CPTICDList = action.payload.results.res;
                state.loading = false;
            }
            // if (action.payload.status === 'error') {
            //     if (action.payload.results === "Token required" || action.payload.results === "Invalid Token") {
            //         state.tokenRequired = true;
            //         state.tokenRequiredMsg = action.payload.results;
            //     }
            // }
        },
        [CPTICDListFetch.rejected]: (state, action) => {
            state.loading = false;
        },
        [fetchSingleCPTICD.pending]: (state, action) => {
            state.loading = true
            state.fetchSingleCPTICD = null

        },
        [fetchSingleCPTICD.fulfilled]: (state, action) => {
            console.log("dash action dataEdit", action)
            state.loading = false;
            state.success = true;
            if (action.payload.status === "success") {
                state.fetchSingleCPTICD = action.payload?.results?.res[0];

            }
        },
        [fetchSingleCPTICD.rejected]: (state, action) => {
            state.loading = false
        },
    }
});

export default CPTICDReducer.reducer;
export const { clearEditDataCPTICD } = CPTICDReducer.actions;